export default "__VITE_ASSET__Bh5NTdqH__"